import { Box } from "@material-ui/core";
import React from "react";
import { makeStyles, Typography, TextField, InputAdornment, Grid,Paper } from "@material-ui/core";
import { GrFormClose } from "react-icons/gr";
import clsx from 'clsx';
import { IoBasketballOutline } from "react-icons/io5";

const useStyles = makeStyles((theme) => ({
  betBox: {
    overflow: "hidden",
    marginTop: "15px",
    background: theme.palette.background.cardbacground,
  },
  header: {

    background: theme.palette.background.heading,
    padding: "10px",
    "& svg": { marginRight: "7px", fontSize: "20px", }
  },
  betdetails: {
    padding: "10px",
  },
  textBoxBet: {
    padding: "10px",
    background: theme.palette.background.heading,
    color:"#fff",
    boxShadow: "inset -10px -10px 20px rgb(255 255 255 / 8%), inset 10px 10px 20px rgb(0 0 0 / 25%)",
    width: "120px", marginRight: "10px",
    "& h5":{
      color:"#fff",
    },
  },
  textField: {
    background: theme.palette.background.heading,
    color: theme.palette.text.white,
    boxShadow: "inset -10px -10px 20px rgb(255 255 255 / 8%), inset 10px 10px 20px rgb(0 0 0 / 25%)",
    borderRadius: "5px",
    "& .MuiFormLabel-root.Mui-focused":{
      color: "#39AED0 !important",
    },
    "& label": {
      color: "#39AED0",
    },
    "&  input": {
      color: theme.palette.text.white,
    },
  },
}));

export default function (props) {
  const classes = useStyles();

  return (
    <Paper className={classes.betBox} elevation={2}>
      <Box className={classes.header}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box className="flexjustify">
              <IoBasketballOutline />
              <Typography variant="body1" color="primary">NBA Finals</Typography>
           </Box>
          </Grid>
          <Grid item xs={6} align="right">
            <img src="images/close_icon.png" alt="image" style={{cursor:"pointer"}} />
        {/* <GrFormClose style={{cursor:"pointer", color
      :"#fff"}}/> */}
          </Grid>


        </Grid>
      </Box>

      <Box className={classes.betdetails}>
      <Box className="flexjustify">
              <img src="images/Los.png" alt="image" style={{ marginRight: "10px",}} />
              <Typography variant="body2" color="primary">Los Angeles Lakers</Typography>
           </Box>
    
        <Box mt={1} className="justifyBetween">
          <Box className={classes.textBoxBet} textAlign="center"><Typography variant="h5" color="primary">1.83</Typography></Box>
          <Typography variant="body2" color="primary">Handicap Handicap Cape
            Verde(-7.5) </Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Wager"
                placeholder="100"
                id="inputID"
                fullWidth
                className={clsx(classes.textField)}
                InputProps={{
                  startAdornment: <InputAdornment position="start" style={{
                    color: " #FA9131",
                    fontSize: "18px"
                  }}><Typography variant="h6">$</Typography></InputAdornment>,
                }}
                variant="filled"
              /></Grid>
            <Grid item xs={6}><TextField
              label="To Win"
              placeholder="183.00"
              id="inputID"
              fullWidth
              className={clsx(classes.textField)}
              InputProps={{
                startAdornment: <InputAdornment position="start" style={{
                  color: " #FA9131",
                  fontSize: "18px"
                }}><Typography variant="h6">$</Typography></InputAdornment>,
              }}
              variant="filled"
            /></Grid>
          </Grid>

        </Box>
      </Box>

    </Paper>
  );
}
